hallAndHallPrimaryNav = function() {
	"use strict";

	var stickyTop = $('.primary-nav').offset().top;
	var primaryNavHeight = $('.primary-nav').outerHeight();

	if($('.filter-nav.navbar').length && isHidden($('.filter-nav.navbar')[0])) {
        var siteHeaderNavHeight = $('.primary-nav').outerHeight();
	} else if($('.filter-nav.navbar').length && !isHidden($('.filter-nav.navbar')[0])) {
        var siteHeaderNavHeight = $('.primary-nav').outerHeight() + $('.filter-nav.navbar').outerHeight();
	} else {
		var siteHeaderNavHeight = $('.primary-nav').outerHeight();
	}

	if($('.financing-site-header.is-absolute').length && $(window).width() > 768) {
		$('.financing-site-header.is-absolute').addClass('is-fixed');
	}

	$(window).on( 'scroll', function(){
		if ($(window).scrollTop() > 0) {
            $('.site-header').addClass('has-scrolled');
			// $('.site-header').addClass('is-fixed');
			// $('.site-header .filter-nav').css('top', primaryNavHeight + 'px');
			// if(!$('.site-header.is-absolute').length) $('.site-content').css('padding-top', siteHeaderNavHeight);
		} else {
            $('.site-header').removeClass('has-scrolled');
			// $('.site-header').removeClass('is-fixed');
			// $('.site-header .filter-nav').css('top', '');
			// $('.site-content').css('padding-top', '');
		}
	});

	// Primary nav close button
	$('.primary-nav .close-btn').on('click', function() {
		$('.navbar-collapse').collapse('hide');
	});

	// Filter nav close button
	$('.filter-nav-xs .close-btn').on('click', function() {
		$(this).closest('.filter-nav-xs').removeClass('is-active');
	});

	// Filter "show all types"
	//$('.filter-nav .list-full').closest('li').addClass('is-full');

	$('.filter-nav .dropdown').on('shown.bs.dropdown', function () {
		$('.filter-nav .list-full').each(function() {
			$( this ).addClass( "foo" );
		});
	});

	$('.filter-nav .filters-select').on('shown.bs.select', function (e) {
		$('.filter-nav .list-full').each(function() {
			$(this).closest('[class*="optgroup-"]').addClass("is-full");
		});
	});

	// Toggle filter mobile menu
	$('.filter-nav .filter-toggle').on('click', function() {
		activateMobileFilter();
	});
	$('.nav-filter-toggle').on('click', function() {
		if($(window).width() <= 1200) {
			activateMobileFilter();
		}
	})
	function activateMobileFilter() {
		$('.filter-nav').find('.filter-collapse').addClass('is-active');
		$('.primary-nav').addClass('is-mobile-active');

		// Set max height for mobile filter dropdowns
		var filterHeight = $('.filter-nav .filter-nav-header').outerHeight() + $('.filter-nav .save-filter-btn').outerHeight();
		var filterDropdownHeight = $(window).height() - filterHeight;
		$('.filter-nav .dropdown-menu').css('max-height', filterDropdownHeight + 'px');

		// Set active state on search button
		$('.filter-nav .save-filter-btn').addClass('is-active');
	}


	// Close filter mobile menu
	$('.filter-nav .close-btn').on('click', function() {
		$(this).closest('.filter-collapse').removeClass('is-active');
		$('.primary-nav').removeClass('is-mobile-active');

		// Remove max height for mobile filter dropdowns
		$('.filter-nav .dropdown-menu').css('max-height', 'none');

		// Remove active state on search button
		$('.filter-nav .save-filter-btn').removeClass('is-active');
	});

	// Filter save button
	$('.filter-nav .save-filter-btn').on('click', function() {
		$(this).closest('.filter-nav').find('.filter-collapse').removeClass('is-active');
		$('.primary-nav').removeClass('is-mobile-active');
		window.scrollTo(0, 0);

		// Remove active state on search button
		$('.filter-nav .save-filter-btn').removeClass('is-active');
	});

	let financeMobileNav = $('#finance-navigation-dropdown');

	$('.finance-navigation-open').on('click', function () {
		financeMobileNav.slideToggle();
	});

};
hallAndHallPrimaryNav();

function isHidden(el) {
    var style = window.getComputedStyle(el);
    return (style.display === 'none')
}
